module.exports = __webpack_public_path__ + "img/blue-marker.b438d06c.svg";